import React from "react";
import Tabs from "../../atoms/Tabs";
import Dropdown from "../../atoms/Dropdown";
import Button from "../../atoms/Button";
import TextEntry from "../../molecules/TextEntry";
import Spacer from "../../atoms/Spacer";
import Text from "../../atoms/Text";

const AdminProductInstantQuote = () => {
  return (
    <div className={"vcl-container-primary-32"}>
      <h1>AdminProductInstantQuote</h1>
      <Tabs
        tabs={[
          {
            id: "instant-quote",
            name: "Instant Quote",
            content: "Instant Quote content",
          },
        ]}
        activeId={"instant-quote"}
        onClick={(id: string) => console.log(id)}
      />
      <div className={"vcl-container-row-spaced"}>
        <Dropdown
          options={["Location 1", "Location 2"]}
          onSelect={() => {}}
          selectedOption={undefined}
          placeholder={"Select a location..."}
        />
        <Button
          label={"Create new instant quote location"}
          type={"button"}
          size={"small"}
          theme={"secondary"}
        />
      </div>
      <div
        className={
          "vcl-container-primary-16 vcl-border-primary vcl-background-cool-gray"
        }
      >
        <TextEntry
          label={"Name"}
          input={{
            id: "location-name",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
        />
        <TextEntry
          label={"Latitude"}
          input={{
            id: "location-latitude",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
          options={{
            lock: {
              isLocked: true,
              unlock: () => {
                console.log("Unlocking");
              },
            },
          }}
        />
        <TextEntry
          label={"Longitude"}
          input={{
            id: "location-longitude",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
          options={{
            lock: {
              isLocked: true,
              unlock: () => {
                console.log("Unlocking");
              },
            },
          }}
        />
        <Spacer
          style={{
            backgroundColor: "var(--black-10)",
            height: "1px",
          }}
        />
        <TextEntry
          label={"Permits & Plans"}
          input={{
            id: "location-1",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
        />
        <TextEntry
          label={"Name"}
          input={{
            id: "location-2",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
        />
        <TextEntry
          label={"Name"}
          input={{
            id: "location-3",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
        />
        <TextEntry
          label={"Name"}
          input={{
            id: "location-4",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
        />
        <TextEntry
          label={"Name"}
          input={{
            id: "location-5",
            placeholder: "",
            required: true,
            type: "text",
            autoComplete: "on",
          }}
        />
        <Spacer
          style={{
            backgroundColor: "var(--black-10)",
            height: "1px",
          }}
        />
        <Text
          text={`Total: $111,111.11`}
          style={{ fontSize: "24px", fontFamily: "Inter-Medium" }}
        />
      </div>
    </div>
  );
};

export default AdminProductInstantQuote;
